import { Dumbbell, Target, TrendingUp, Activity } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { VolumeAnalysis } from "@/lib/volume-balance";

interface VolumeStatsGridProps {
  analysis: VolumeAnalysis;
  weeksAnalyzed: number;
}

export function VolumeStatsGrid({ analysis, weeksAnalyzed }: VolumeStatsGridProps) {
  const topMuscle = analysis.muscleGroups[0];
  const uniqueMuscles = analysis.muscleGroups.length;
  
  const stats = [
    {
      icon: Dumbbell,
      label: "Total Sets",
      value: analysis.totalSets.toLocaleString(),
      subtext: `${analysis.weeklyAverage.sets}/week avg`,
      color: "text-primary",
      bg: "bg-primary/10",
    },
    {
      icon: Activity,
      label: "Total Volume",
      value: analysis.totalVolume > 10000 
        ? `${(analysis.totalVolume / 1000).toFixed(1)}k` 
        : analysis.totalVolume.toLocaleString(),
      subtext: "lbs lifted",
      color: "text-success",
      bg: "bg-success/10",
    },
    {
      icon: Target,
      label: "Muscle Groups",
      value: uniqueMuscles.toString(),
      subtext: "trained",
      color: "text-info",
      bg: "bg-info/10",
    },
    {
      icon: TrendingUp,
      label: "Top Focus",
      value: topMuscle?.muscleGroup 
        ? topMuscle.muscleGroup.charAt(0).toUpperCase() + topMuscle.muscleGroup.slice(1)
        : "—",
      subtext: topMuscle ? `${topMuscle.percentage.toFixed(0)}% of volume` : "",
      color: "text-warning",
      bg: "bg-warning/10",
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <Card key={index} className="border-0 bg-card/50">
            <CardContent className="pt-6">
              <div className="flex items-center gap-3">
                <div className={`h-10 w-10 rounded-xl ${stat.bg} flex items-center justify-center`}>
                  <Icon className={`h-5 w-5 ${stat.color}`} />
                </div>
                <div>
                  <p className="text-2xl font-bold">{stat.value}</p>
                  <p className="text-xs text-muted-foreground">{stat.subtext || stat.label}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
